import {AgendaSectionProps} from 'Event/template/Townhall/Dashboard/Main/AgendaSection'
import {useTownhallTemplate, useTownhallUpdate} from 'Event/template/Townhall'
import {generateHashId} from 'lib/crypto/hash'
import {useAddTranslation, useTranslationLanguage} from 'Event/LanguageProvider'
import {parseVariables} from 'lib/template'

export function useDuplicateAgenda(sectionId: string) {
  const template = useTownhallTemplate()
  const save = useTownhallUpdate()
  const addTranslation = useAddTranslation()
  const targetLanguage = useTranslationLanguage()

  return (sourceId: string) => {
    const section = template.dashboardSections[sectionId] as AgendaSectionProps
    const source = section.items[sourceId]
    if (!source) {
      return
    }

    const position = Object.keys(section.items).length + 1
    const translations =
      template.localization?.translations?.[targetLanguage] ?? {}

    const resolve = (value: string | null | undefined) => {
      const [variable] = parseVariables(value ?? '')
      return variable ? translations[variable] ?? '' : value ?? ''
    }

    return generateHashId([
      'townhall_',
      'agenda_item',
      Date.now().toString(),
      Math.random().toString(),
    ]).then((id) => {
      save({
        localization: addTranslation({
          [`dashboardSections_${sectionId}_items_${id}_text`]: resolve(
            source.text,
          ),
          [`dashboardSections_${sectionId}_items_${id}_description`]: resolve(
            source.description,
          ),
          [`dashboardSections_${sectionId}_items_${id}_link`]: resolve(
            source.link,
          ),
        }),
        dashboardSections: {
          [sectionId]: {
            items: {
              [id]: {
                ...source,
                position,
                text: `{{dashboardSections_${sectionId}_items_${id}_text}}`,
                description: `{{dashboardSections_${sectionId}_items_${id}_description}}`,
                link: `{{dashboardSections_${sectionId}_items_${id}_link}}`,
              },
            },
          },
        },
      })
    })
  }
}
